import { render } from "./main-target.vue?vue&type=template&id=6a669316&scoped=true"
import script from "./main-target.vue?vue&type=script&lang=js"
export * from "./main-target.vue?vue&type=script&lang=js"

import "./main-target.vue?vue&type=style&index=0&id=6a669316&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a669316"]])

export default __exports__